module.exports = __webpack_public_path__ + "img/2023-24.a4e59d38.jpg";